import logo from './logo.svg';
import './App.css';
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import { Route, Routes } from 'react-router-dom';
import Login from './Components/Login/Login';
import Register from './Components/Register/Register';
import Update from './Components/Update/Update';
import ManageInventory from './Components/ManageInventory/ManageInventory';
import AddItem from './Components/AddItem/AddItem';
import Blogs from './Components/Blogs/Blogs';
import Notfound from './Components/NotFound/Notfound';
import MyItem from './Components/Myitem/MyItem';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Routes>
        <Route path='/' element={<Home></Home>}>Home</Route>
        <Route path='/login' element={<Login></Login>}>Home</Route>
        <Route path='/additem' element={<AddItem></AddItem>}>AddItem</Route>
        <Route path='/register' element={<Register></Register>}>Home</Route>
        <Route path='/blog' element={<Blogs></Blogs>}>Blog</Route>
        <Route path='/myitem' element={<MyItem></MyItem>}>MyItem</Route>
        <Route path='/update/:id' element={<Update></Update>}></Route>
        <Route path='/manageinvemtory' element={<ManageInventory></ManageInventory>}></Route>
        <Route path='*' element={<Notfound></Notfound>}></Route>
      </Routes>
    </div>
  );
}

export default App;
